// extracted by mini-css-extract-plugin
module.exports = {"image":"VariantsSection-module--image--27sWi"};